import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { ProfileResponse } from 'src/app/models/profile-response.model'

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  public static readonly profileEndpoint = '/profile'
  private readonly _profileDataSource = new BehaviorSubject<ProfileResponse>(
    null,
  )
  public profileDataSource$ = this._profileDataSource.asObservable()

  constructor(
    private readonly http: HttpClient,
    private readonly titleService: Title,
    private readonly metaService: Meta,
  ) {}

  getProfile(fundId: string): Observable<ProfileResponse> {
    fundId = fundId.toUpperCase()
    return this.http.get<ProfileResponse>(
      `vmf/api/${fundId}`.concat(ProfileService.profileEndpoint),
    )
  }

  setMeta(profile: ProfileResponse) {
    if (profile?.fundProfile?.isExternalFund) {
      this.metaService.addTag({ name: 'robots', content: 'noindex, nofollow' })
    }
  }

  getAssociatedFundTickers(
    profile: ProfileResponse,
  ): Observable<ProfileResponse> {
    if (
      profile?.fundProfile?.associatedFundIds &&
      Object.keys(profile.fundProfile.associatedFundIds).length
    ) {
      const associatedFundIds = []
      const idMap = {}
      profile.fundProfile.associatedFundTickers = {}
      profile.fundProfile.associatedFundLongnames = {}
      Object.keys(profile.fundProfile.associatedFundIds).forEach((key) => {
        idMap[associatedFundIds.length] = key
        associatedFundIds.push(
          this.getProfile(profile.fundProfile.associatedFundIds[key]),
        )
      })
      return forkJoin(associatedFundIds).pipe(
        switchMap((response: ProfileResponse[]) => {
          response.forEach((associatedFund: ProfileResponse, i) => {
            profile.fundProfile.associatedFundTickers[idMap[i]] =
              associatedFund.fundProfile.ticker
            profile.fundProfile.associatedFundLongnames[idMap[i]] =
              associatedFund.fundProfile.longName
          })

          return of(profile)
        }),
      )
    } else {
      return of(profile)
    }
  }

  setProfileDataSource(profileData: ProfileResponse): void {
    this._profileDataSource.next(profileData)
  }
}
